var React = require('react');
var helpers = require('svg-react-loader/helpers')(require('react-dom'));

module.exports = React.createClass({

    displayName: "MessageUnreadCircle",

    getDefaultProps () {
        return {"xmlns":"http://www.w3.org/2000/svg","className":"dibsvg-svg dibsvg-message-unread-circle","viewBox":"0 0 250 250"};
    },

    componentDidMount () {
        helpers.applyXmlAttributes(this);
    },

    render () {
        var props = this.props;
        var children = props.children;

        return (
            <svg {...this.props}>
                  <path d="M204.1 19.2c-21.4 0-39.5 14.8-44.5 34.7H0v175.3h223V107c15.9-7.2 27-23.3 27-41.8 0-25.4-20.6-46-45.9-46zm-45.9 43.7c0 .7-.1 1.5-.1 2.3 0 10.7 3.7 20.6 9.8 28.4L113.1 159 29.4 62.9h128.8zM9 220.3V62.9h8.5l95.7 110 61-72.9c8 6.9 18.4 11 29.8 11 3.4 0 6.7-.4 9.9-1.1v110.4H9z"/>
  <circle cx="203.8" cy="65.1" r="46.3" className="unread-circle"/>
                {React.Children.map(children, (c) => (c))}
            </svg>
        );
    }
});



// WEBPACK FOOTER //
// ./src/message-unread-circle.svg